export enum RolePermission {
    ReadArrivalDepartures = 1110,
    UpdateArrivalDepartures = 1120,
    CreateTimetables = 1200,
    ReadTimetables = 1210,
    UpdateTimetables = 1220,
    DeleteTimetables = 1230,
    CreatePassengers = 1300,
    ReadPassengers = 1310,
    ReadAllPassengerTrips = 1315,
    UpdatePassengers = 1320,
    UpdatePassengerGroups = 1321,
    DeletePassengers = 1340,
    CreateBookings = 1400,
    ReadBookings = 1410,
    UpdateBookings = 1420,
    DeleteBookings = 1430,
    CreateTransportationPermissions = 1500,
    ReadTransportationPermissions = 1510,
    UpdateTransportationPermissions = 1520,
    DeleteTransporetationPermissions = 1530,
}

export class Role {
    id: number;
    name: string;
    permissions: number[];

    public static fromApi(apiRole: any): Role {
        const role = new Role();
        role.id = apiRole.id;
        role.name = apiRole.name;
        role.permissions = apiRole.permissions;
        return role;
    }
}

export default Role;
